import {PipelineStepStatusCode, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

export interface AnalysisProgressStep {
  id: string;
  statusCode: PipelineStepStatusCode;
  stepType: PipelineStepType;
}

export interface AnalysisProgress {
  numSteps: number;
  /** Steps that have finished running: succeeded, or halted by the analysis's own logic. */
  numCompletedSteps: number;
  failedSteps: Array<AnalysisProgressStep>;
  /** Whether the analysis is sending its data to a notebook entry. */
  isSendingData: boolean;
}

/** How far an analysis's execution has got, from the statuses of its steps. */
export function getAnalysisProgress(steps: ReadonlyArray<AnalysisProgressStep>): AnalysisProgress {
  return {
    numSteps: steps.length,
    numCompletedSteps: steps.filter(
      (step) =>
        step.statusCode === PipelineStepStatusCode.SUCCEEDED ||
        step.statusCode === PipelineStepStatusCode.HALTED
    ).length,
    failedSteps: steps.filter((step) => step.statusCode === PipelineStepStatusCode.FAILED),
    isSendingData: steps.some(
      (step) =>
        step.statusCode === PipelineStepStatusCode.RUNNING &&
        step.stepType === PipelineStepType.SEND_TO_DOCUMENT
    ),
  };
}

/** Progress as a percentage of steps completed. */
export function getAnalysisProgressPercent({numSteps, numCompletedSteps}: AnalysisProgress): number {
  return numSteps === 0 ? 0 : (100 * numCompletedSteps) / numSteps;
}
